import React,{useRef,useEffect,useState, useCallback} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { createTheme, List } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from 'axios'
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import ListItem from '@mui/material/ListItem';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';


const drawerWidth = 300;



const materialTheme = createTheme(({
    // set default for now
  }));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
  productListPaper: {
  
    marginBottom: 50,
  },
  
  paper: {
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
  },
  appBarBottom: {
    top: 'auto',
    bottom: 0,
    [theme.breakpoints.up('sm')]: {
      },
  },
  grow: {
    flexGrow: 1,
  },
}));



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const PoDateSettings = (props) => {
    const classes = useStyles();
    const [isSavingSettings, setIsSavingSettings] = useState(false)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [messageDialogMessage,setMessageDialogMessage] = useState("")
    const [isSavingSuccess,setIsSavingSuccess] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [actionMessage, setActionMessage] = useState("");
    const [showProgressDialog, setShowProgressDialog] = useState("");
    const [showDeleteProductDialog, setShowDeleteProductDialog] = useState(false)
    const [settings, setSettings] = useState({
        value : 1
    })

    
    const messageDialog = () => {
        return(
            <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={showMessageDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
               {messageDialogMessage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{
                
                    setShowMessageDialog(false)

                    if(isSavingSuccess){
                        props.setOpenDialogSettings(false)
                    }
                    
                  }} 
                color="primary" autoFocus>
                Close
              </Button>
            </DialogActions>
          </Dialog>
          )
    }

    const progressDialog = () => {
        return(
          <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          open={isSavingSettings}
          onClose={()=>{}}
        >
         
          <DialogContent>
            <DialogContentText>
              Saving Settings... Please wait...
            </DialogContentText>
            <LinearProgress color="secondary" />
          </DialogContent>
        </Dialog>
        )
    }
    
    
    const menuHandleClose = () => {
        setShowDeleteProductDialog(false)
    };

    useEffect(()=> {
        
        

    },[isSavingSettings])

    
    useEffect(()=> {
        
        fetchExistingSettings();

    },[])

    const fetchExistingSettings = async () => {
        setIsLoading(true)

        const options = {
            method : "POST",
            url : '/TransactiLiteGeneralSettings/getSellerPoDateSettings.json',
        }

        await axios(options)
        .then((res) => {
            setIsLoading(false)

            
            const message = res.data.response.message;
            const is_success = res.data.response.is_success;
            const settings = res.data.response.settings;

            if (!is_success) {
                setShowMessageDialog(true)
                setMessageDialogMessage(message)
                return
            }

            if (settings.length != 0) {
                setSettings(settings[0])
            }

        })
        .catch((error) => {
            setIsLoading(false)

            setShowMessageDialog(true)
            setMessageDialogMessage(error)

        })
    }

    const inputOnChangeListener = (event)=>{
        const modifiedSettings = {...settings}

        modifiedSettings[event.target.name] = event.target.value
        setSettings(modifiedSettings)

    }

    const handleInputKeyPress = (event) => {
        if (!/^[0-9.]*$/.test(event.key)) {
        event.preventDefault();
        }
    }

    const handlePaste = (event) => {
        event.preventDefault();

        const pastedText = event.clipboardData.getData('text/plain');
        const sanitizedText = pastedText.replace(/[^\d]/g, ''); // Remove non-numeric characters
        document.execCommand('insertText', false, sanitizedText);
    };
    
    const handleSaveSettings = async () => {

        setIsSavingSettings(true);

        const options = {
            method : "POST",
            url : '/TransactiLiteGeneralSettings/saveTransactiSellerPODateSettings.json',
            data: objectToFormData({
                settings : JSON.stringify(settings)
            })
        }

        await axios(options)
        .then((res) => {

            setIsSavingSettings(false)
            const message = res.data.response.message;

            setIsSavingSuccess(true)
            setShowMessageDialog(true)
            setMessageDialogMessage(message)
            
        })
        .catch((error) => {
            setIsSavingSettings(false)

            setShowMessageDialog(true)
            setMessageDialogMessage(error)
        })
    }
    
    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);
        
      return formData;
    }, new FormData());

    return (
        <div>
            <Dialog 
                fullScreen 
                open={props.openDialogSettings} 
                onClose={()=>{props.setSelectedSettings({name:""})}} 
                TransitionComponent={Transition}
            >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{
                            
                            props.setOpenDialogSettings(false)
                            
                        }
                            
                            
                        }
                        aria-label="close"
                        size="large">
                    <CloseIcon />
                    </IconButton>
                    <Typography variant="subtitle1" className={classes.title}>
                        {"Transacti Seller Transaction PO Date Settings"}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.appBarSpacer}></div>
            
            <Paper square className={classes.productListPaper}>
                    
                <div style={{padding:'.5rem'}}>

                    <Grid container spacing={1}style={{ marginBottom: '.5rem' }}>
                        <Grid item xs={12}>
                            <Grid item xs={12} >Number of Days</Grid>
                            <Grid item xs={12}>
                                <StyledEngineProvider injectFirst>
                                    <ThemeProvider theme={materialTheme}>
                                    <form noValidate>
                                        <TextField
                                            autoComplete='off'
                                            type='text'
                                            className={classes.fullWidth}
                                            value={settings.value}
                                            name="value"
                                            id="value"
                                            rows={4}
                                            variant="outlined"
                                            onChange={inputOnChangeListener}
                                            onKeyPress={handleInputKeyPress} // Handle key press to restrict input
                                            onPaste={handlePaste}
                                        />
                                    </form>
                                    </ThemeProvider>
                                </StyledEngineProvider>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item container>
                        <Button variant="contained" color="primary" style={{width:"100%"}} onClick={handleSaveSettings}>
                            Save
                        </Button>
                    </Grid>

                </div>
               
            </Paper>
            <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
                {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
            </AppBar>
            <AppBar position="fixed"  style={{ background: 'transparent', boxShadow: 'none'}} className={classes.appBarBottom}>
                
            </AppBar>
            
    </Dialog>
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
            {progressDialog()}
            {messageDialog()}
            </ThemeProvider>
    </StyledEngineProvider>
     </div>
    );
}

export default PoDateSettings